const sData = [
  {
    symbol: "AAPL",
    company: "Apple Inc.",
    change: 0.67,
    marketCap: 2500000000000,
    previousClose: 149.58,
    week52High: 182.94,
    week52Low: 116.21,
    ytdChange: 0.12,
    peRatio: 29.74,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 150.25,
    price: 229.432,
    iexCloseTime: "4:00 PM EDT",
    time: "4:05 PM IST",
    currency: "USD",
    percentChange: 12.43,
  },
  {
    symbol: "MSFT",
    company: "Microsoft Corporation",
    price: 305.223,
    percentChange: -0.32,
    change: -0.98,
    time: "3:59 PM EDT",
    marketCap: 2300000000000,
    previousClose: 306.20,
    week52High: 349.67,
    week52Low: 232.73,
    ytdChange: 0.23,
    peRatio: 34.12,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 305.22,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "GOOGL",
    company: "Alphabet Inc.",
    price: 2734.652,
    percentChange: 0.12,
    change: 3.25,
    time: "3:59 PM EDT",
    marketCap: 1800000000000,
    previousClose: 2731.40,
    week52High: 3037.00,
    week52Low: 2011.49,
    ytdChange: 0.15,
    peRatio: 28.56,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 2734.65,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "AMZN",
    company: "Amazon.com Inc.",
    price: 3450.964,
    percentChange: -0.76,
    change: -26.25,
    time: "3:59 PM EDT",
    marketCap: 1700000000000,
    previousClose: 3477.21,
    week52High: 3773.08,
    week52Low: 2950.12,
    ytdChange: 0.08,
    peRatio: 61.58,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 3450.96,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "TSLA",
    company: "Tesla Inc.",
    price: 729.402,
    percentChange: 1.50,
    change: 10.79,
    time: "3:59 PM EDT",
    marketCap: 700000000000,
    previousClose: 718.61,
    week52High: 900.40,
    week52Low: 540.60,
    ytdChange: 0.32,
    peRatio: 187.45,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 729.40,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "FB",
    company: "Meta Platforms Inc.",
    price: 355.649,
    percentChange: -0.25,
    change: -0.89,
    time: "3:59 PM EDT",
    marketCap: 1000000000000,
    previousClose: 356.53,
    week52High: 384.33,
    week52Low: 244.61,
    ytdChange: 0.20,
    peRatio: 30.48,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 355.64,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "NFLX",
    company: "Netflix Inc.",
    price: 593.297,
    percentChange: 0.10,
    change: 0.58,
    time: "3:59 PM EDT",
    marketCap: 260000000000,
    previousClose: 592.71,
    week52High: 700.99,
    week52Low: 480.58,
    ytdChange: -0.05,
    peRatio: 51.45,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 593.29,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "NVDA",
    company: "NVIDIA Corporation",
    price: 198.406,
    percentChange: -1.14,
    change: -2.28,
    time: "3:59 PM EDT",
    marketCap: 470000000000,
    previousClose: 200.68,
    week52High: 223.85,
    week52Low: 112.83,
    ytdChange: 0.60,
    peRatio: 45.78,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 198.40,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "INTC",
    company: "Intel Corporation",
    price: 54.399,
    percentChange: -0.18,
    change: -0.10,
    time: "3:59 PM EDT",
    marketCap: 220000000000,
    previousClose: 54.49,
    week52High: 68.49,
    week52Low: 45.24,
    ytdChange: 0.07,
    peRatio: 12.25,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 54.39,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  },
  {
    symbol: "CSCO",
    company: "Cisco Systems Inc.",
    price: 58.651,
    percentChange: 0.29,
    change: 0.17,
    time: "3:59 PM EDT",
    marketCap: 240000000000,
    previousClose: 58.48,
    week52High: 60.27,
    week52Low: 44.15,
    ytdChange: 0.10,
    peRatio: 19.87,
    primaryExchange: "NASDAQ",
    isUSMarketOpen: false,
    iexClose: 58.65,
    iexCloseTime: "4:00 PM EDT",
    currency: "USD"
  }
];

  export default sData;